export const LOADED = "LOADED";
export const SENT = "SENT";
export const APPENDED = "APPENDED";
export const PAGINATION = "PAGINATION";
export const STATE_CHANGE = "STATE_CHANGE";
